export class DetailFlightPrices {
  COMAI = 0
  IND = 0
  INDAI = 0
  CLA = 0
  CLAAI = 0
  PAU = 0
  PAUAI = 0
  LIG = 0
}